import { noop } from 'lodash';
import { RevisionActionProps } from 'components/tables/data/revision/types';
import { useApi } from 'api/api-context';
import panic from 'errors/panic';
import { showNotification } from '@mantine/notifications';
import { SUCCESS_NOTIFICATION_COLOR } from 'utils/constants';

/**
 * The parameters of the reject action.
 */
export interface ReturnActionParams extends RevisionActionProps {
  reason?: string;
}

/**
 * Implements the return action for revision.
 */
export default function useReturnAction() {
  const { getAction } = useApi();

  /**
   * Makes a call to the API to return the revision.
   */
  async function returnRevision({
    revision: { revisionId, revisionName, kind },
    reason,
    onStatusChange = noop,
  }: ReturnActionParams) {
    const revisionReturnAction = getAction('RevisionCustomerReturn');

    try {
      const { status } = await revisionReturnAction({
        parameters: { revisionId: String(revisionId) },
        payload: { reason },
      });

      onStatusChange({ revisionId, status, reason });

      showNotification({
        title: kind === 'revision' ? 'Revízna správa bola zamietnutá' : 'Formulár bol zamietnutý',
        message:
          kind === 'revision'
            ? `Revíznu správu ${revisionName} ste úspešne zamietli.`
            : `Formulár ${revisionName} ste úspešne zamietli.`,
        color: SUCCESS_NOTIFICATION_COLOR,
      });
    } catch (error: any) {
      panic(error);
    }
  }

  return { returnRevision };
}
